import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

window.Fancybox = Fancybox;
window.Fancybox.bind('[data-fancybox]', {});
